module.exports = __webpack_public_path__ + "img/about_banner@1x.f6e5d654.png";